export const currencyDisplay = (amount?: number, isCents: boolean = true): string => {
  if (amount === undefined) {
    return '';
  }

  if (isCents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount / 100);
  } else {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  }
};
